module.exports = __webpack_public_path__ + "img/freewave2_03.a36bfd8b.jpg";